import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import { rem } from '../../utilities/style';
import { colors } from '../../theme/colors';

import { ReactComponent as IconArrowRight } from '../../images/icons/arrow-right.svg';

const ArrowStyled = styled(IconArrowRight)``;

const Button = styled.button`
  position: relative;
  z-index: 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: ${rem(56)};
  height: ${rem(56)};
  border: 0;
  background: none;
  color: ${colors.blue['800']};
  cursor: pointer;

  ${({ theme }) => theme.pageOverrides?.includes('Dark Mode') && `
    color: ${colors.blue['100']};
  `}

  &:hover {
    &:not([disabled])::before {
      transform: scale(1.1);
    }
  }

  &::before {
    content: '';
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: ${rem(40)};
    background-color: ${colors.gray['100']};
    transition: transform .2s ease;
    ${({ theme }) => theme.pageOverrides?.includes('Dark Mode') && `
      background-color: #002747;
    `}
  }

  ${ArrowStyled} {
    ${({ left }) => left && 'transform: scaleX(-1)'}
  }
`;

const ButtonArrow = forwardRef(({
  left = false,
  disabled = false,
  className,
  onClick,
  'aria-label': ariaLabel
}, ref) => (
  <Button
    left={left}
    className={className}
    onClick={onClick}
    aria-label={ariaLabel}
    disabled={disabled}
    ref={ref}
  >
    <ArrowStyled aria-hidden="true" />
  </Button>
));

ButtonArrow.propTypes = {
  left: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
  'aria-label': PropTypes.string
};

// Convert to styled component so we can reference it in other component styles
export default styled(ButtonArrow)();
